import { apiRoutes } from '../../api-routes';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type {
  IntercityOrderRequest,
  IntercityPackageDetail,
  IntercityServiceRequest,
} from '../intercity/types';
import type { DiscountDetail } from '../new-order';
import type { IntercityPath } from '../place';
import type { ApiError } from '../types';

export interface EstimateIntercityOrderRequestBody {
  path: IntercityPath[];
  services: IntercityServiceRequest[];
  package_detail: IntercityPackageDetail[];
  payment_method_id: string;
  promo_code?: string;
  promo_code_ids?: string[];
  package_images: string[] | null;
}
export type EstimateNewOrderRequestBody = {
  path: IntercityPath[];
  services: IntercityServiceRequest[];
  package_detail: IntercityPackageDetail[];
  payment_method: string;
  promo_code?: string;
  promo_code_ids?: string[];
  package_images: string[] | null;
  order_time?: number;
  idle_until?: number;
};

export interface EstimateIntercityOrderResponse {
  service_id: string;
  error?: ApiError;
  data?: EstimateIntercityOrderData;
  promo_error_message?: string;
}

export type EstimateIntercityOrderData = {
  distance: number;
  distance_fee: number;
  stop_fee: number;
  weight_fee: number;
  request_fee: number;
  discount: number;
  total_cod?: number;
  total_fee: number;
  total_pay: number;
  total_price: number;
  vat_fee: number;
  cod_commission_fee: number;
  online_pay: number;
  voucher_discount: number;
  surge_rate: number;
  special_request_price: number;
  subtotal_price: number;
  vat: number;
  distance_price: number;
  stoppoint_price: number;
  weight_price: number;
  cod_commission_price: number;
  total_balance: number;
  requests: IntercityOrderRequest[];
  payment_method: string;
  partner_id: string;
  promo_error_message?: string;
  polylines?: string;
  require_transportation_documents?: boolean;
  discount_details?: DiscountDetail[];
};

export const estimateIntercityOrderFn = async (
  body: EstimateIntercityOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<EstimateIntercityOrderResponse[]>(
    apiRoutes.intercity.estimate,
    body,
    config
  );

  return response.data;
};
